
import pako from 'pako';
import { shortCodeMap } from '../constants';

/**
 * Decodes a selection hash from the URL (#/selection/...)
 * Returns a string of codes separated by spaces.
 */
export const decodeSelectionToCodes = (hash: string): string => {
  try {
    let base64 = hash.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) { base64 += '='; }
    const binaryStr = atob(base64);
    const bytes = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
    }
    const decompressedString = pako.inflate(bytes, { to: 'string' });
    
    const codes: string[] = [];
    decompressedString.split('|').forEach(part => {
        const [shortCode, idsStr] = part.split(':');
        const collection = shortCodeMap[shortCode];
        if (collection && idsStr) {
            const ids = idsStr.split(',');
            ids.forEach(id => {
                if (id) {
                    // We return the codes as they are in the selection string
                    // Usually these are the "codigo" or "codigo_brp"
                    // If the selection string contains IDs, we might need a different approach
                    // But based on the user request, they want to "pegar los codigos"
                    codes.push(id);
                }
            });
        }
    });
    return codes.join(' ');
  } catch (e) {
    console.error("Failed to decode selection hash:", e);
    return '';
  }
};
